export default __webpack_public_path__ + "static/media/search-DE.2dce006c.png";